import React, { useState } from 'react';
import { Grid, Box } from '@mui/material';
import styles from './errors.module.scss';
import { Error } from 'components/Error';
import { Validation } from 'components/Validation';
import { useSearchParams } from 'react-router-dom';

const Errors = () => {
  const [searchParams] = useSearchParams();
  const validation = searchParams.get('Validation');
  const [tab, setTab] = useState(validation ? 1 : 0);

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const tabs = [{ label: 'Error Logs' }, { label: 'Validation Table' }];

  const renderContent = () => {
    switch (tab) {
      case 0:
        return (
          <Error handleTabChange={handleTabChange} tab={tab} tabs={tabs} />
        );
      case 1:
        return (
          <Validation handleTabChange={handleTabChange} tab={tab} tabs={tabs} />
        );
      default:
        return null;
    }
  };

  return (
    <Box className={styles.dashboardContainer}>
      <Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {renderContent()}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Errors;
